import { Logger } from '../utilities/logger';
import { AbstractView } from './abstract-view';
/**
 * A view displaying consent information in a top bar.
 *
 * @author Philipp Seiler <sep@earlybird.at>
 */
export class TopView extends AbstractView {
    constructor(api, container) {
        super(api, container);
        Logger.debug('top-view', 'Starting to construct.');
        Logger.debug('top-view', 'Finished constructing.');
    }
    show() {
        this.emitter.emit('show', this);
        Logger.info('top-view', 'Show.');
        this.container.ariaHidden = 'false';
        this.emitter.emit('shown', this);
    }
    hide() {
        this.emitter.emit('hide', this);
        Logger.info('top-view', 'Hide.');
        this.container.ariaHidden = 'true';
        this.emitter.emit('hidden', this);
    }
}
